module.exports = __webpack_public_path__ + "media/images/athletes/4329-0dc5f960879dd810f9cd3bb2dde52e78.png";